export const joblabel = {
  pageSize: {
    width: 283.5,
    height: 226.77
  },
  pageOrientation: 'landscape',
  pageMargins: [ 0, 27, 0, 0 ],
  info: {
    title: '',
    author: 'PHM-Industrieanlagen GmbH, Burg',
    subject: '',
    revison: 'Rev 02/2025',
  },
  background: function(currentPage: number, pageCount: number) {
    var address = '';
    var revisionNo = 'Rev 02/2025';
    if (currentPage === 1) { address = 'PHM-Industrieanlagen GmbH · Kiefernweg 17 · 39288 Burg'; }
    return [
      {
        svg: '<svg x="190" viewBox="0 0 300 200">' +
          '<style type="text/css">.st0{fill:#FFFFFF;}.st1{fill:#E8E000;}.st2{fill:#002E55;}.st3{clip-path:url(#SVGID_00000043422101159610038430000017566189734938454690_);fill:#002E55;}.st4{font-family:MyriadPro-Regular;}.st5{font-size:15.621px;}</style>' +
          '<rect x="179.9" y="0" class="st1" width="52.6" height="56.2"/>' +
          '<polygon class="st2" points="100.8,52.6 100.8,5 83.5,5 83.5,23.7 70.2,23.7 70.2,5 52.8,5 52.8,52.6 70.2,52.6 70.2,37.1,83.5,37.1 83.5,52.6 "/>' +
          '<polygon class="st2" points="173.7,52.6 173.7,5 148.9,5 139.5,33.7 139.4,33.7 130.8,5 105.4,5 105.4,52.6 120.4,52.6 120.4,20.4,120.6,20.4 133.6,52.6 144.3,52.6 158.1,20.4 158.3,20.4 158.3,52.6 "/>' +
          '<g>' +
          '<defs>' +
          '<rect id="SVGID_1_" y="0" width="232.4" height="78"/>' +
          '</defs>' +
          '<clipPath id="SVGID_00000107585377674912480690000000636542520813620910_">' +
          '<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>' +
          '</clipPath>' +
          '<path style="clip-path:url(#SVGID_00000107585377674912480690000000636542520813620910_);fill:#002E55;" d="M49.7,26.2c0-4-0.6-7.4-1.8-10.1c-1.2-2.7-2.9-4.9-5-6.5c-2.1-1.6-4.6-2.8-7.5-3.5c-2.9-0.7-6-1.1-9.3-1.1H4.8v51.2h17.3v-7.8h0v-14v-2.8V17.3h2.6c2.7,0,4.8,0.7,6.3,2.1c1.5,1.4,2.3,3.6,2.3,6.6c0,2.6-0.8,4.6-2.3,6.1c-1.4,1.4-3.3,2.1-5.5,2.2v12.3h3.7c3,0,5.8-0.5,8.3-1.4s4.7-2.2,6.5-4c1.8-1.7,3.2-3.9,4.2-6.4C49.2,32.3,49.7,29.4,49.7,26.2"/>' +
          '</g>' +
          '<text class="st-2" transform="matrix(1 0 0 1 6.0903 73.6413)">Industrieanlagen GmbH</text>' +
          '</svg>',
        fit: [ 200, 80 ]
      }
    ]
  },
  content: [
    {
      layout: 'noBorders',
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 0,
        widths: [ 'auto', 'auto' ],

        body: [
          [ { text: 'Job PHM:', style: 'fett' }, { text: '96.0023.0006.1' } ],
          [ { text: 'Best.-Nr. Knd:', style: 'fett' }, { text: '0049/FEN/11820027' } ],
          [ { text: 'Bauteilname:', style: 'fett' }, { text: 'Hohlwelle EB geschweißt' } ],
          [ { text: 'Menge:', style: 'fett' }, { text: '5' } ],
          [ { text: 'Zeichnungsnr.:', style: 'fett' }, { text: '313519 2Fle143.0.45.011.001 Ausgabe 01 / 04-04' } ],
          [ { text: 'Material:', style: 'fett' }, { text: 'S355J2, 1.0577 +N' } ],
          [ { text: 'Charge:', style: 'fett' }, { text: '' } ],
          [ { text: 'Ser.-Nr.:', style: 'fett' }, { text: '' } ]
        ]
      },
      style: 'normal',
      margin: [ 20, 5]
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [ '30%', '35%', '35%' ],

        body: [
          [
            { text: ''}, { text: 'Datum'} , { text: 'Unterschrift'},
          ],
          [ { text: 'Freigabe'}, ' ', ' ' ],
          [ { text: 'Sperrung'}, ' ', ' ' ],
          [ [ 'Freigabe', { text: 'nach Sperrung' , style: 'small' } ], ' ', ' ' ]
        ]
      },
      style: 'table',
      margin: [ 20, 0]
    },

  ],

  styles: {
    header: {
      fontSize: 10,
      bold: true
    },
    table: {
      fontSize: 9,
      bold: false
    },
    normal: {
      fontSize: 9,
      bold: false
    },
    fett: {
      fontSize: 9,
      bold: true
    },
    small: {
      fontSize: 6,
      bold: false
    }
  }
};
